import { ApiError } from '../errors/api-error.js';

export class OperationalRunService {
    constructor(api) {
        this.api = api;
    }

    async _invoke(method, ...args) {
        try {
            return await this.api[method](...args);
        } catch (error) {
            if (error instanceof ApiError) throw error;
            throw ApiError.fromResponse(error);
        }
    }

    getAll(params = {}) { return this._invoke('getAll', params); }
    getById(id) { return this._invoke('getById', id); }
    startFromCrisis(sourceId, data = {}) { return this._invoke('startFromCrisis', sourceId, data); }
    startFromExercise(sourceId, data = {}) { return this._invoke('startFromExercise', sourceId, data); }
    getBoard(id) { return this._invoke('getBoard', id); }
    getHistory(id, params = {}) { return this._invoke('getHistory', id, params); }
    getUpdates(id, params = {}) { return this._invoke('getUpdates', id, params); }
    appendUpdate(id, data) { return this._invoke('appendUpdate', id, data); }
    startTask(id, taskId) { return this._invoke('startTask', id, taskId); }
    completeTask(id, taskId, data = {}) { return this._invoke('completeTask', id, taskId, data); }
    listTaskEvidence(id, taskId) { return this._invoke('listTaskEvidence', id, taskId); }
    uploadTaskEvidence(id, taskId, file) { return this._invoke('uploadTaskEvidence', id, taskId, file); }
    downloadTaskEvidence(id, taskId, evidenceId) {
        return this._invoke('downloadTaskEvidence', id, taskId, evidenceId);
    }
    overrideDependencies(id, taskId, data) { return this._invoke('overrideDependencies', id, taskId, data); }
    reassignTask(id, taskId, data) { return this._invoke('reassignTask', id, taskId, data); }
    pause(id, data) { return this._invoke('pause', id, data); }
    resume(id, data = {}) { return this._invoke('resume', id, data); }
    complete(id, data = {}) { return this._invoke('complete', id, data); }
    cancel(id, data) { return this._invoke('cancel', id, data); }
}
